<template>
  <div id="core-drawer-toolbar">
    <!-- toolbarr start -->
    <v-toolbar flat fixed>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>ThemeSine</v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-flex align-center layout py-2>

          <v-text-field v-if="responsiveInput" label="Search..." color="purple"></v-text-field>

          <v-menu bottom left  offset-y transition="slide-y-transition">

            <div v-ripple slot="activator" class="toolbar-items" >
              <v-badge color="error" overlap>
                <template slot="badge">
                  {{ notifications.length }}
                </template>
                <v-icon >mdi-bell</v-icon>
              </v-badge>
            </div>

            <v-card>
              <v-list dense>
                <v-list-tile v-for="notification in notifications" :key="notification" @click="onClick">
                  <v-list-tile-title v-text="notification"/>
                </v-list-tile>
              </v-list>
            </v-card>

          </v-menu>

          <router-link v-ripple class="toolbar-items" to="/about">
            <v-icon>mdi-account</v-icon>
          </router-link>

        </v-flex>
      </v-toolbar-items>

    </v-toolbar>
    <!-- toolbar end -->

    <v-navigation-drawer v-model="drawer" app class="sidebar">
        <div class="sidebar-logo">
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <h2>ThemeSine</h2>
        </div>
        <v-list dense>
          <v-text-field v-if="responsive" label="Search..." color="#42b983"></v-text-field>

          <!-- single item -->
          <v-list-tile v-for="(link, i) in links" :key="i" :to="link.to">
            <v-list-tile-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title v-text="link.text"/>
          </v-list-tile>

          <!-- multiple item -->
          <v-list-group  v-for="item in items"  v-model="item.active" :key="item.title"  :prepend-icon="item.action" no-action >

            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile  v-for="(subItem,i) in item.items" :key="i" :to="subItem.to" >

              <v-list-tile-content>
                <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <v-icon>{{ subItem.action }}</v-icon>
              </v-list-tile-action>

            </v-list-tile>

          </v-list-group>

          <!-- single item -->
          <v-list-tile  to="/maps">
            <v-list-tile-action>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Maps</v-list-tile-title>
          </v-list-tile>

        </v-list>
      </v-navigation-drawer>
  </div>
</template>

<script>
  export default {
    data: () => ({
      notifications: [
        "Mike, John responded to your email",
        "You have 5 new tasks",
        "You're now a friend with Andrew",
        "Another Notification",
        "Another One"
      ],
      links: [
        {
          to: "/",
          icon: "mdi-view-dashboard",
          text: "Dashboard"
        },
        {
          to: "/about",
          icon: "mdi-account-multiple",
          text: "About"
        }
      ],
      items: [
        {
          action: 'mdi-chart-areaspline',
          title: 'Charts',
          active: false,
          items: [
            { title: 'Chartist', to: "/chartist" },
            { title: 'Charts', to: "/charts" }
          ]
        },
        {
          action: 'mdi-view-dashboard',
          title: 'UI Component',
          active: false,
          items: [
            { title: 'Grids', to: "/grids" },
            { title: 'Alerts', to: "/alerts" },
            { title: 'Carousel', to: "/carousel" }
          ]
        }
      ],
      drawer: null,
      responsive: false,
      responsiveInput: false
    }),
    mounted () {
      this.onResponsiveInput();
      window.addEventListener("resize", this.onResponsiveInput);
    },
    methods : {
      onResponsiveInput() {
        if (window.innerWidth < 991) {
          this.responsive = true;
          this.responsiveInput = false;
        } else {
          this.responsive = false;
          this.responsiveInput = true;
        }
      },
      onClick() {
        //
      }
    }
  }
</script>
